<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>房车管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>房车品牌列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>房车品牌列表</span>
        </div>
        <span class="xcx-add left font14" @click="dialogFormVisible = true">添加品牌</span>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="100"></el-table-column>
          <el-table-column prop="title" label="品牌名称" width="120"></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column prop="sort" label="排序" width="80"></el-table-column>
          <el-table-column label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="自定义属性" width="30%" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="品牌名称" :label-width="formLabelWidth" prop="title">
          <el-input v-model="ruleForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      dialogFormVisible: false,
      ruleForm: {
        title: "",
        sort: "",
      },
      search: {
        keys: "",
      },
      rules: {
        title: [{ required: true, message: "请填写品牌", trigger: "blur" }],
      },
      formLabelWidth: "120px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/car_brand/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/car_brand/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => { });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/car_brand/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/car_brand/store";
        if (that.id) {
          formData.id = that.id;
          url = "/car_brand/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.ruleForm.title = "";
          that.ruleForm.sort = "";
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>